import Vue from "vue";
import ACheckbox from "+/components/form/checkbox/Checkbox";

export const checkboxFormatter = function (cell) {
  let ComponentClass = Vue.extend(ACheckbox);
  let instance = new ComponentClass({
    propsData: {
      value: cell.getValue().value,
      name: cell.getValue().name
    }
  });
  instance.$mount();
  return instance.$el;
};
